import React from 'react';

import { BASE_ICONS } from 'src/components/svg';
import { popupModel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, withRouter } from 'src/helpers';

import { MCButton } from 'src/components/basic';

import model from './model';

import LANG_CONST from 'src/helpers/lang/const';
import { AddGallery } from './Add';
import { GalleryList } from './List';

class Gallery extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  renderList = () => {
    return (
      <div className={'mc-setting-location mc-setting-form mc-grow'}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.gallery)}</div>
          <MCButton
            primary
            light
            medium
            radius
            type={'button'}
            label={LANG_CONST.buttons.main_gallery}
            onClick={() =>
              popupModel.setActivePopup('add_profile_gallery', {
                active: true,
                component: AddGallery,
                props: {
                  onSave: model.saveData,
                  isMain: true
                }
              })
            }
          />
          <MCButton
            primary
            light
            medium
            radius
            type={'button'}
            label={LANG_CONST.buttons.add_gallery}
            iconname={BASE_ICONS.PLUS}
            onClick={() =>
              popupModel.setActivePopup('add_profile_gallery', {
                active: true,
                component: AddGallery,
                props: {
                  onSave: model.saveData,
                  isMain: false,
                  gallery: model.state.gallery
                }
              })
            }
          />
        </div>
        <div className={'mc-container-content__body-content mc-p30 mc-grow'}>
          <GalleryList />
        </div>
      </div>
    );
  };

  render() {
    return <div className={'mc-main-content mc-flex-col'}>{this.renderList()}</div>;
  }
}

export default withRouter(Gallery);
